import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Children, createContext, isValidElement, useContext, useEffect, useRef, } from 'react';
const ScrollContext = createContext('');
const ScrollProvider = ScrollContext.Provider;
function useScrollKey() {
    const context = useContext(ScrollContext);
    if (!context) {
        throw new Error('Scroller context was not found');
    }
    return context;
}
export function Scroller(props) {
    const { scrollTo, children } = props;
    const isAllScrollItem = Children.toArray(children).some((child) => isValidElement(child) && child.type === ScrollerElement);
    if (!isAllScrollItem && Children.count(children) > 0) {
        throw new Error("one of the children should be of type <Scroller.Item elementKey='...' > children </Scroller.Item>");
    }
    return _jsxs(ScrollProvider, { value: scrollTo, children: [" ", children, " "] });
}
function ScrollerElement(props) {
    const { children, elementKey } = props;
    const scrollToKey = useScrollKey();
    const ref = useRef(null);
    useEffect(() => {
        if (ref.current && elementKey === scrollToKey) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [elementKey, scrollToKey]);
    return _jsx("div", { ref: ref, children: children });
}
Scroller.Item = ScrollerElement;
